export default class Ship {

    constructor(x, y, group) {
        this.x=x-33;
        this.y=y-18;
        this.group = group;

        this.shipItself = game.add.sprite(this.x, this.y, 'ship', "ship_base.png", group);
        this.floor = game.add.sprite(this.x, this.y, 'ship', "floor_base.png", group);
        this.fire = game.add.sprite(this.x + 20, this.y + this.shipItself.height/2, 'ship', 'fire01.png', group);
        this.fire.animations.add('firing', ["fire01.png", "fire02.png"], 8, true).play();
        this.fire.anchor.set(1, 0.5);
        this.fire.moveDown();
        this.fire.moveDown();
        let fireShown = true;
        this.fire.update = () => {
            if (game.gameState.energy === 0 && fireShown) {
                if (this.fire.tween) this.fire.tween.stop();
                fireShown = false;
                this.fire.tween = game.add.tween(this.fire.scale).to({x:0.2, y:0.2}, 500, null, true);
            }
            if (game.gameState.energy > 0 && !fireShown) {
                if (this.fire.tween) this.fire.tween.stop();
                fireShown = true;
                this.fire.tween = game.add.tween(this.fire.scale).to({x:1, y:1}, 300, null, true);
            }
        }
    }

    showInGameShip() {
        this.shipItself.visible = true;
        this.floor.visible = true;
    }

    getBounds() {
        return new Phaser.Rectangle(this.shipItself.left, this.shipItself.top, this.shipItself.width, this.shipItself.height);
    }

    centerCamera() {
        game.camera.bounds = undefined;
        game.camera.setPosition(-(game.canvas.width-this.shipItself.width+130)/2, -(game.canvas.height-this.shipItself.height)/2)
    }

}


// WEBPACK FOOTER //
// ./src/objects/ship.js